import { ProductTypeName } from '@electricjs/core_entity-client';

import i18n from '@/i18n';

const getProductTypeNameMap = (): Record<ProductTypeName, string> => ({
  laptop: i18n.t('assets:tableFilters.productTypes.laptop'),
  desktop: i18n.t('assets:tableFilters.productTypes.desktop'),
  mouse: i18n.t('assets:tableFilters.productTypes.mouse'),
  keyboard: i18n.t('assets:tableFilters.productTypes.keyboard'),
  keyboard_mouse: i18n.t('assets:tableFilters.productTypes.keyboardMouse'),
  monitor: i18n.t('assets:tableFilters.productTypes.monitor'),
  dock: i18n.t('assets:tableFilters.productTypes.dock'),
  audio: i18n.t('assets:tableFilters.productTypes.audio'),
  video: i18n.t('assets:tableFilters.productTypes.video'),
  warranty: i18n.t('assets:tableFilters.productTypes.warranty'),
  miscellaneous: i18n.t('assets:tableFilters.productTypes.miscellaneous'),
  cell_phone: i18n.t('assets:tableFilters.productTypes.cellPhone'),
  other_phone: i18n.t('assets:tableFilters.productTypes.otherPhone'),
  tablets: i18n.t('assets:tableFilters.productTypes.tablets'),
  headphones: i18n.t('assets:tableFilters.productTypes.headphones'),
  microphone: i18n.t('assets:tableFilters.productTypes.microphone'),
  power_adapter: i18n.t('assets:tableFilters.productTypes.powerAdapter'),
  cable: i18n.t('assets:tableFilters.productTypes.cable'),
  accessory: i18n.t('assets:tableFilters.productTypes.accessory'),
  service: i18n.t('assets:tableFilters.productTypes.service'),
  shipping_and_handling: i18n.t(
    'assets:tableFilters.productTypes.shippingAndHandling'
  ),
});

export default function getProductTypeLabel(
  productType: ProductTypeName
): string {
  const productTypeNameMap = getProductTypeNameMap();
  return productTypeNameMap[productType] ?? productType; // default to the enum value
}
